import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';

const QUERY = gql(`
  query getExistingNarrative($companyId: String!, $loggedIn: Boolean!) {
    Company(id: $companyId) {
      data {
        currencyInfo
      }
      analysisValue {
        lastSharePrice
        npvPerShare
      }
      myValuation @include(if: $loggedIn) {
        fairValue
        narrative {
          id
          valuations {
            fairValue
            updatedAt
          }
        }
      }
    }
  }
`);

export const useExistingNarrative = makeGqlQuery(QUERY, {
  tags: ['narrative'],
});
